import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { featureFlagNames } from '@ipfabric/utils';
import classNames from 'classnames';
import type { FC } from 'react';

import { isFeatureFlagEnabled } from '@ipfabric/ui-components/utils/featureFlags';

export const FeatureFlagsGallerySection: FC = () => {
  return (
    <>
      <h3>Configuration</h3>
      <table>
        {featureFlagNames.map((flagName) => (
          <div
            key={flagName}
            className={classNames(
              'font-semibold',
              isFeatureFlagEnabled(flagName)
                ? 'text-green-500'
                : 'text-red-500',
            )}
          >
            <Icon
              className='mr-2'
              glyph={
                isFeatureFlagEnabled(flagName)
                  ? 'fa-toggle-on'
                  : 'fa-toggle-off'
              }
              inline
            />
            {flagName}
          </div>
        ))}
      </table>
    </>
  );
};
